import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { CommonCieModel } from 'src/app/model/common/cie';

export interface CommonCieState {
  result: VonPageResponseModel<CommonCieModel>;
}

export const commonCieIS: CommonCieState = {
  result: {
    content: [],
    last: false,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0,
  },
};
